export default __webpack_public_path__ + "static/media/customer-journey-analysis.97a39931.gif";